<template>
<div>
  <div class='invite'>
    <div class="friend">推荐奖励</div>
    <div class="item-box">
        <!-- <img src="@/assets/images/peo.jpg" style="width:100%;display:block"> -->
          <img width="100%" style="width:100%;display:block" src="@/assets/images/peoplepp.jpg">     
        <div class="invite_link">
          邀请链接: 
          <input class="" id="foo" type="text" 
           :value="link"
           readonly="readonly">
        </div>    
        <div class="invite_link1 invite_btn"  data-clipboard-action="copy" data-clipboard-target="#foo">
             复制推荐链接
        </div>
	</div>
    <!-- <div class="main">
          <img width="100%" style="width:100%;display:block" src="@/assets/images/peoplepp.jpg">     
    </div> -->
  </div>
  </div>
</template>
<script>
import VueClipboard from 'clipboard'
export default {
    name:"invite-friend",
    data(){
        return{
          link:"http://fw.jd.com/1631.html?source=&t=img"//链接地址
        }
    },
    methods:{
      
    },
    created () {
      // 埋点
    this.buriedPoint(1, '推荐奖励', '后台管理', '推荐奖励')
    },
    mounted() {
        let ele=document.getElementsByClassName(".invite_btn");
        let Clipboard=new VueClipboard(".invite_btn");
        Clipboard.on("success",e=>{
            this.$message.success("复制成功");
        })
    }
}
</script>
<style lang="scss" scoped>
   .invite{
       min-width: 1046px;
       background-color: #fff;
       -webkit-border-radius: 6px;
       -moz-border-radius: 6px;
       border-radius: 6px;
       padding: 0px 28px 30px 28px;
       -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
       box-sizing: border-box;
       background:rgba(255,255,255,1);
       box-shadow:0px 4px 8px rgba(0,0,0,0.1);
       opacity:1;
       margin: 10px 20px;
       .friend{
             font-size:16px;
             font-weight:bold;
             line-height:22px;
             color:rgba(46,52,88,1);
             opacity:1;
             padding: 15px 15px!important;
             border-bottom: 1px solid #f6f6f6;
        }
       .item-box{
           width:100%;
           position:relative;
           margin-top: 15px;
           box-sizing: border-box;
           .invite_link{
            width: 50%;
            text-indent: 30px;
            border-radius: 75px;
            position: absolute;
            top: 35%;
            left: 20%;
            // right: 0;
            margin: 0 auto;
            color: #3d200b;
            font-size: 18px;
            background: #fff;
              input{
                  padding: 1% 0;
                  color: #3d200b;
                  border: 0;
                  outline:none;
                  font-size: 18px;
                  width: 68%;
              }
           }
           .invite_link1{
              position: absolute;
              display: inline-block;
              top: 35%;
              right:20%;
              width:8%;
              height:36px;
              background:rgba(255,211,123,1);
              border-radius:20px;
              text-align: center;
              line-height: 36px;      
              color: #D21728;    
              cursor: pointer;
           }
          @media screen and (max-width: 1475px) {
           .invite_link1 {
                width: 10%;
                right: 18%;
                height: 32px;
                line-height: 32px;
            }
          }
          @media screen and (max-width: 1200px) {
           .invite_link1 {
                     width: 10%;
                      right: 18%;
                     height: 32px;
                     line-height: 32px;
                }
           }
       }
   }
</style>